<template>
  <Navbar></Navbar>
  <Banner />
  <div class="content-wrapper">
    <div class="main-content">
      <CertificateContent />
    </div>
    <FooterItem />
  </div>
</template>

<script>
import Navbar from "@/components/Layout/Navbar.vue";
import CertificateContent from "@/components/Certificate/CertificateContent.vue";
import FooterItem from "@/components/Layout/FooterItem.vue";
import { useHead } from "@vueuse/head";
import { mapGetters } from "vuex";
import store from "@/store";
export default {
  components: {
    Navbar,
    CertificateContent,
    FooterItem,
  },
  computed: {
    ...mapGetters(["currentLanguage"]),
  },
  methods: {
    updateHeadMeta() {
      const title =
        this.currentLanguage === "ar"
          ? "شهادات التدريب - Planning Force | اعتمد إنجازاتك التعليمية"
          : "Certificates - Planning Force | Validate Your Learning Achievements";

      const description =
        this.currentLanguage === "ar"
          ? "استعرض واعتمد شهاداتك التدريبية التي حصلت عليها من خلال Planning Force، وأظهر إنجازاتك التعليمية."
          : "Showcase and validate your training certificates earned through Planning Force, and highlight your learning achievements.";

      const keywords =
        this.currentLanguage === "ar"
          ? "شهادات, شهادات تدريبية, Planning Force, اعتماد الإنجازات, التعليم الإلكتروني"
          : "certificates, training certificates, Planning Force, validate achievements, e-learning";

      useHead({
        title: title,
        meta: [
          { name: "description", content: description },
          { name: "keywords", content: keywords },
          { name: "robots", content: "index, follow" },
          {
            name: "author",
            content:
              this.currentLanguage === "ar"
                ? "معهد Planning Force العالي للتدريب"
                : "Planning Force High Institute for Training",
          },
          {
            name: "language",
            content: this.currentLanguage === "ar" ? "ar" : "en",
          },

          // Open Graph meta tags
          { property: "og:title", content: title },
          { property: "og:description", content: description },
          {
            property: "og:image",
            content: "https://example.com/certificate-og-image.jpg",
          }, // Replace with your certificate page image URL
          { property: "og:url", content: "https://example.com/certificates" }, // Replace with your certificate page URL
          { property: "og:type", content: "website" },

          // Twitter Card meta tags
          { name: "twitter:card", content: "summary_large_image" },
          { name: "twitter:title", content: title },
          { name: "twitter:description", content: description },
          {
            name: "twitter:image",
            content: "https://example.com/certificate-twitter-image.jpg",
          }, // Replace with your certificate page image URL
        ],
      });
    },
  },
  mounted() {
    this.updateHeadMeta();
  },
  watch: {
    currentLanguage: {
      handler(newLang, oldLang) {
        this.updateHeadMeta();
        store.dispatch("categoriesList");
      },
      immediate: true, // Run the handler immediately when the component is mounted
    },
  },
};
</script>
